export class NavBtn {
 btn:[];
constructor(init?:Partial<NavBtn>) {
        Object.assign(this, init);
    }
}